// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f1e9a1a8","455":"08db1506","977":"02950e07"}[chunkId] + ".chunk.js";
};